<div class="mb-2"
     *ngIf="price !== undefined">
  <span [translate]="'cakeBuilder.cakeQuestionSection.cost'"></span>&nbsp;
  <span>{{price | currencyFormat}} {{currency}}</span>
</div>
<div class="form-group mb-2">
  <ui-expandable-textarea
    [placeholder]="'common.textareaPlaceholder' | translate"
    [(model)]="answer"
    [rows]="1"
    [maxLength]="maxLength || null"
    [allowEmoji]="false"
    (modelChange)="onChange.emit(answer)">
  </ui-expandable-textarea>
</div>
<div class="fw-bold font-sm" *ngIf="maxLength">
  {{ 'common.limitLetters' | translate:{ "length": answer?.length || 0, "maxLength": maxLength } }}
</div>
